import { render, staticRenderFns } from "./carousel-campaign.vue?vue&type=template&id=3bc80b02&scoped=true&"
import script from "./carousel-campaign.vue?vue&type=script&lang=js&"
export * from "./carousel-campaign.vue?vue&type=script&lang=js&"
import style0 from "./carousel-campaign.vue?vue&type=style&index=0&id=3bc80b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc80b02",
  null
  
)

export default component.exports